module.exports = __webpack_public_path__ + "static/yae-miko-78967ce0ae9b3ffec13786f1fdc2f259.png";